import React from 'react';
import styles from './Section.module.css';

const FAQComponent = () => (
  <div className={styles.contentSection}>
    <div className={styles.sectionContent}>
      <div className={styles.subSectionTitle}>Start your game journey</div>
      <h4>Can I register on your website?</h4>
      <p>You must be at least 18 years old or reach the age of majority under your jurisdiction. You must be permitted to play online games by the laws applicable to you. For more information, please read our terms and conditions.</p>
      <p>Games might be addictive, and players are advised to be self-control.</p>
    </div>

    <div className={styles.sectionContent}>
      <div className={styles.subSectionTitle}>Account Information</div>
      <h4>1. What if I forget my password?</h4>
      <p>If you forget your password, you could reset it within 15 seconds through our "Forget password" link. After applying for password reset, please follow the instructions in the email we send to you to reset your password.</p>

      <h4>2. I have lost my mobile phone. How do I reset my Google authenticator?</h4>
      <p>If you want to remove your Google authenticator 2FA, please contact us. After we receive your application, for the safety of your account, you are required to answer several security questions correctly in order to remove the 2FA.</p>

      <h4>3. Can I change my username or registered email address?</h4>
      <p>Sorry, but we are not able to update this information. If you insist on changing your username and/or registered email, we suggest you close the current account and register a new one.</p>

      <h4>4. How do I become a VIP?</h4>
      <p>The exclusive VIP club is by invitation only. After you embark on your journey of the game, you will be notified of your VIP status by email soon.</p>
    </div>

    <div className={styles.sectionContent}>
      <div className={styles.subSectionTitle}>My wallet</div>
      <p>"My wallet" is part of the player account. You can view the balance of all cooperative cryptocurrencies, deposit and withdraw and query transaction records. Furthermore, you can also get access to NG Swap without review and Vault Pro with an annual percentage rate (APR) of 5%.</p>
    </div>

    <div className={styles.sectionContent}>
      <div className={styles.subSectionTitle}><span className={styles.primaryText}>Deposit</span></div>
      <h4>What is NG Swap</h4>
      <p>You can use NG Swap to exchange cryptocurrencies without waiting for review.</p>

      <h4>What is Vault Pro</h4>
      <p>This is the NG exclusive bank that you can get annual percentage rate (APR) of 5% from your deposit in the Vault Pro.</p>

      <h4>How to withdraw</h4>
      <p>find the "My wallet" page, open the withdraw page, enter the address of the wallet you need to withdraw and the amount of cryptocurrency (pay attention to the fee). After clicking the confirm button, the cryptocurrency will be transferred to your wallet (pay attention to the corresponding cryptocurrency).</p>

      <div className={styles.subSectionTitle}><span className={styles.primaryText}>Withdraw</span></div>

      <h4>Minimum Withdraw amount</h4>
      <p>Because the value of each cryptocurrency is different, the minimum Withdraw amount is also different</p>

      <h4>How long does it take to deposit and withdraw?</h4>
      <p>Each transaction on the blockchain requires several cycles to confirm the transfer has been recorded successfully. Generally speaking, each transaction requires 5-10 minutes before it can be confirmed by the blockchain network. If you encounter any problem during deposit or Withdraw, you can visit www.blockchain.info to check your transaction, or contact technical support.</p>

      <h4>Before Withdraw, how many confirmations is required on my deposit?</h4>
      <p>To withdraw, your total deposit requires at least 3 verifications. You may check the current verification progress information by clicking on the deposit link in the cashier page.</p>

      <h4>Where do transaction confirmations come from?</h4>
      <p>All confirmation information comes from the wallet supplier, the blockchain and miners.</p>

      <h4>How long does it take to confirm a transaction?</h4>
      <p>It depends on the blockchain and your transfer fee. It might take 10 minutes or several hours.</p>

      <h4>Is your game fair and just?</h4>
      <p>We are based on the Ethereum smart contract. All data and core logic on the blockchain are transparent, and manipulation is not possible. Every single transaction on the blockchain can be tracked on etherscan. The fairness, openness, and justness of us gaming platform are guaranteed.</p>

      <h4>What should I do if my game hangs or there is a problem?</h4>
      <p>If you encounter any technical problem while playing our games, please try to refresh the game. Normally it will work after refresh. Should the problem persist, please contact us.</p>
    </div>
  </div>
);

export default FAQComponent;
